<template>
  <div class="blog">
    <div class="flex -m-20 min-h-screen mx-auto text-center justify-center items-center">
      <h1 class="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-pink-500">
        This is the blog page
      </h1>
    </div>
  </div>
</template>
